import { ArrowRight, Rocket, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const CTASection = () => {
  const navigate = useNavigate();
  return (
    <section className="py-24 relative overflow-hidden px-4 sm:px-6 lg:px-8 xl:px-12">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-purple-500/20 to-accent/20" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,hsl(var(--background))_70%)]" />
        
        {/* Animated Gradient Orbs */}
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary/30 rounded-full blur-[100px] animate-pulse" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-accent/30 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: "1s" }} />
      </div>

      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass border border-primary/20 mb-8">
            <Rocket className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium">🚀 Ready to Scale?</span>
          </div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6">
          Turn Your Vision Into Scalable Technology.            <span className="gradient-text"> today.</span>
          </h2>

          {/* Description */}
          <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
          From custom development to long-term support, we handle the complete lifecycle of your digital product — with dedicated developers and 2 years of free support.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" className="text-lg px-8 h-14 glow-primary bg-gradient-to-r from-primary to-purple-600 hover:opacity-90 transition-all group" onClick={() => navigate("/contact#contact-form")}>
                Let's Talk About Your Project
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            {/* <Button size="lg" variant="outline" className="text-lg px-8 h-14 glass border-border/50 hover:bg-primary/5" onClick={() => navigate("/contact#contact-form")}>
              Schedule Demo
            </Button> */}
          </div>

          {/* Features List */}
          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
            {[
              "Custom development",
              "Dedicated development team",
              "2 years of free support",
              "Long-term commitment",
            ].map((feature) => (
              <div key={feature} className="flex items-center gap-2">
                <Sparkles className="w-4 h-4 text-primary" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};